/** Default editor height — shared between the Suspense fallback and the impl. */
export const DEFAULT_HEIGHT = '200px';

/** Background colors for each theme — used by the Suspense fallback. */
export const THEME_BACKGROUNDS = {
  light: '#fafafa',
  dark: '#242651',
} as const;
